(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DataInput.OpportunitiesDataInput",
                    {
                        url: "/Opportunities",
                        component: "opportunitiesDataInputComponent",
                        PageTitle: "Opportunities Data Input | Marketing Tracker",
                    });
        }
    ]);

    app
        .component("opportunitiesDataInputComponent",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/MainDataInput/OpportunitiesDataInput/opportunities-data-input.template.html",
                controller: opportunitiesDataInputController,
                bindings: {
                    today: '<',
                    sources: '<',
                    advisors: '<',
                    statuses: '<',
                    dateSelect: '<',
                    selectedDate: '<',
                }
            });

    opportunitiesDataInputController.$inject = ['marketingTrackerSalesTrackerInputApi', '_', '$filter', 'figToaster', '$timeout', '$mdDialog'];

    function opportunitiesDataInputController(marketingTrackerSalesTrackerInputApi, _, $filter, figToaster, $timeout, $mdDialog) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                disableRow: false,
                loadingRows: false,
                lostStatusName: 'Lost',
                columnName: 'Date',
                filterString: '',
                reverseOrder: true,
                table: {
                    header: [
                        {
                            name: 'Date',
                            displayName: 'Date',
                            required: true
                        },
                        {
                            name: 'ClientName',
                            displayName: 'Client',
                            required: true
                        },
                        {
                            name: '[Advisors[0].Name, Advisors[1].Name, Advisors[2].Name, Advisors[3].Name]',
                            displayName: 'Advisor',
                            required: true
                        },
                        {
                            name: 'Status.StatusName',
                            displayName: 'Status',
                            required: true
                        },
                        {
                            name: 'Source.SourceName',
                            displayName: 'Source',
                            required: true
                        },
                        {
                            name: 'OpportunityAmount',
                            displayName: 'Opportunity',
                            required: false
                        },
                        {
                            name: 'SoldAmount',
                            displayName: 'Sold',
                            required: false
                        },
                        /* {
                             name: "RemainingAssets",
                             displayName: "Remaining Assets",
                             required: false
                         },*/
                        {
                            name: 'FirstAppointmentDate',
                            displayName: 'First Appt.',
                            required: false
                        },
                        {
                            name: 'NextFollowUpDate',
                            displayName: 'Next Follow Up',
                            required: false
                        },
                        {
                            name: 'Notes',
                            displayName: 'Notes',
                            required: false
                        },
                    ],
                    body: []
                },
                model: {
                    Date: $ctrl.today,
                    ClientName: '',
                    Advisors: [],
                    Status: '',
                    Source: '',
                    OpportunityAmount: 0,
                    SoldAmount: 0,
                    AssociatedSalesSoldAmount: 0,
                    FirstAppointmentDate: '',
                    NextFollowUpDate: '',
                    Notes: '',
                },
                Indices: resetIndices(),
                /*openSalesHistory: openSalesHistory,*/
            });

        var message, toastClass = '';

        function resetFormModel() {
            $ctrl.form.$setPristine();
            $ctrl.form.$setUntouched();
            $ctrl.model = {
                Date: $ctrl.today.toLocaleDateString(),
                ClientName: '',
                Advisors: [],
                Status: '',
                Source: '',
                OpportunityAmount: 0,
                SoldAmount: 0,
                FirstAppointmentDate: '',
                NextFollowUpDate: '',
                Notes: '',
            };
        }

        // make copy to compare changes on auto-save
        function copyTable() {
            $ctrl.table.bodyDupe = ng.copy($ctrl.table.body);
        }

        function getRowsByDateRange(selectedDate, enableLoading) {
            $ctrl.loadingRows = enableLoading === 'false' ? false : true;
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;

            return marketingTrackerSalesTrackerInputApi.getOpportunitiesByDate(startDate, endDate)
                .then(function (response) {
                    $ctrl.table.body = response;
                    copyTable();
                    $ctrl.loadingRows = false;
                });
        }

        function resetIndices() {
            return {
                StartIndex: 0,
                IndexIncrement: 25,
                EndIndex: 0,
                Limit: 50
            };
        }

        $ctrl.increaseLimit = function () {
            $ctrl.Indices.Limit += $ctrl.Indices.IndexIncrement;
        };

        function deleteRow(model) {
            return marketingTrackerSalesTrackerInputApi.deleteOpportunity(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        }

        $ctrl.orderRows = function (columnName) {
            if (columnName) {
                $ctrl.reverseOrder = (columnName === $ctrl.columnName) ? !$ctrl.reverseOrder : false;
                $ctrl.columnName = columnName;
            } else {
                columnName = $ctrl.columnName;
            }
            $ctrl.table.body = $filter('orderBy')($ctrl.table.body, columnName, $ctrl.reverseOrder);
            copyTable();
        };

        $ctrl.filterByDate = function (selectedDateRange) {
            getRowsByDateRange(selectedDateRange)
                .then(function () {
                    $ctrl.orderRows(false);
                });
        };

        $ctrl.addRow = function (model) {
            if ($ctrl.form.$invalid) throw Error('Invalid field');
            if (!model.Date) model.Date = $ctrl.today;
            $ctrl.disableRow = true;
            return marketingTrackerSalesTrackerInputApi.createOpportunity(model)
                .then(function (response) {
                    message = 'New row added';
                    toastClass = 'is-success';
                    $ctrl.addingRow = false;
                    resetFormModel();
                    $ctrl.table.body.unshift(response);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    $ctrl.disableRow = false;
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };

        $ctrl.toggleEditRow = function (row, index) {
            row.edit = !row.edit;
            $ctrl.table.bodyDupe[index].edit = row.edit;
        };

        $ctrl.updateRow = function (row, form, index, logData) {
            // TODO: Figure out why air-datepicker input on template always trigger a form submission per instance whenever row.edit === true. Uncomment console logs below to see
            // console.log(row, $ctrl.table.bodyDupe[index]);
            // console.log(ng.equals(row, $ctrl.table.bodyDupe[index]));
            // if (logData) console.log(logData);
            
            if (form.$invalid) return;
            if (ng.equals(row, $ctrl.table.bodyDupe[index])) return;
            else {
                row.OpportunityAmount = !!row.OpportunityAmount ? row.OpportunityAmount : '0.00';
                return marketingTrackerSalesTrackerInputApi.updateOpportunity(row)
                    .then(function () {
                        copyTable();
                    })
                    .catch(function () {
                        message = 'Sorry, an error has occurred. Please try again later.';
                        toastClass = 'is-error';
                        getRowsByDateRange($ctrl.selectedDate, 'false');
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            }
        };

        // ng-blur & ng-change changes how things are fired. FYI
        $ctrl.updateCell = function (row, cellName, index, parentIndex) {
            if (parentIndex) {
                console.log('Not implemented'); // TODO: Use parentIndex when refactoring to handle nested arrays such as lob amounts
            } else {
                if (ng.equals(row[cellName], $ctrl.table.bodyDupe[index][cellName])) return;
                else {
                    return marketingTrackerSalesTrackerInputApi['updateOpportunity' + cellName](row.Id, row[cellName])
                        .then(function () {
                            copyTable();
                        })
                        .catch(function () {
                            message = 'Sorry, an error has occurred. Please try again later.';
                            toastClass = 'is-error';
                            getRowsByDateRange($ctrl.selectedDate, 'false');
                            return figToaster.showSimple(message, "top", toastClass);
                        });
                }
            }
        };

        $ctrl.deleteWithUndo = function (model) {
            model.showUndo = true;
            model.deferDelete = $timeout(function () {
                deleteRow(model, index);
            }, 1800);
            return deleteRow(model);
        };

        $ctrl.undoDeleteRow = function (model) {
            $timeout.cancel(model.deferDelete);
            model.showUndo = false;
        }

        $ctrl.deleteRow = function (model) {
            return marketingTrackerSalesTrackerInputApi.deleteOpportunity(model.Id)
                .then(function () {
                    message = 'Row deleted';
                    toastClass = 'is-success';
                    $ctrl.table.body = _.without($ctrl.table.body, model);
                    copyTable();
                })
                .catch(function () {
                    message = 'Sorry, an error has occurred. Please try again later.';
                    toastClass = 'is-error';
                })
                .finally(function () {
                    return figToaster.showSimple(message, "top", toastClass);
                });
        };

        $ctrl.openAddSaleFromOpportunityModal = function (row) {
            if (cannotOpenAddSaleFromOpportunityModal(row)) {
                figToaster.showSimple("Unable to create sale from lost opportunity", "top", "is-error", 5000)
            }
            else {
                $mdDialog.show(
                    {
                        controller: "addSaleController",
                        controllerAs: "$ctrl",
                        templateUrl: "App/Tools/MarketingTrackerNew/Components/AddSale/add-sale.component.html",
                        bindToController: true,
                        opportunity: row,
                        sources: $ctrl.sources,
                        resolve: {
                            history: ["marketingTrackerSalesTrackerInputApi", function (marketingTrackerSalesTrackerInputApi) {
                                return marketingTrackerSalesTrackerInputApi.getOpportunitySales(row.Id);
                            }],
                        }
                    })
                    .then(function (soldAmount) {
                        row.AssociatedSalesSoldAmount += soldAmount;
                    })
            }
        }

        function cannotOpenAddSaleFromOpportunityModal(row) {
            return row.Status.StatusName == $ctrl.lostStatusName || (row.ParentStatus && row.ParentStatus.StatusName == $ctrl.lostStatusName);
        }

        $ctrl.export = function (selectedDate) {
            var startDate, endDate = null;
            startDate = selectedDate.value.startDate;
            endDate = selectedDate.value.endDate;
            marketingTrackerSalesTrackerInputApi.postExportOpportunities(startDate, endDate).then(function (data) {
                var objectUrl = URL.createObjectURL(data);
                var a = document.createElement("a");
                a.style = "display:none";
                a.href = objectUrl;
                a.download = "Opportunities.xlsx";
                a.click();
            });
        };

        $ctrl.$onInit = function () {
            getRowsByDateRange($ctrl.selectedDate).then(function () {
                $ctrl.orderRows(false);
            });
        };
/*
        function openSalesHistory(opportunity) {
            return $mdDialog.show({
                templateUrl: "App/Tools/MarketingTrackerNew/MainDataInput/OpportunitiesDataInput/SalesHistory/sales-history-template.html",
                controller: "salesHistoryController",
                controllerAs: "$ctrl",
                locals: {
                    opportunity: opportunity,
                    user: $ctrl.user,
                },
                bindToController: true
            })
                .then(function (response) {
                    amplitudeService.logClickEvent('Sales History');
                    *$ctrl.toggleCalSideNav();
                    $ctrl.onEventAddedFn({ response: response });
                    return figToaster.showSimple("Event added.", "top", "is-success");*
                });
        }*/
    }

})(window.app, window.angular); //jshint ignore:line